<template>
  <div class="container-fluid">
    <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm">
      <b-row class="mx-auto justify-content-end"
        v-if="job_obj.status != 'complete' && ((user_type == 'admin') ||
          (job_obj && job_obj.owner && job_obj.owner.type == user_type && job_obj.owner.id == user_id) ||
          (user_type == 'operator' && job_obj.operator != null && job_obj.operator.id == user_id && is_staff==0) 
         )">
        <b-col cols="auto">
          <router-link class="btn btn-bumblebee btn-garden-help btn-garden-help-primary-link btn-lg py-1"
            :to="base_url + '/edit'">
            <font-awesome-icon icon="fa-solid fa-pen-to-square"  />
            Edit Job
          </router-link>
        </b-col>
      </b-row>

      <b-row class="mx-auto">
        <b-col>
          <b-card no-body class="my-2">
            <b-card-header class="">
              <b-row cols-md="2" cols="1" class="">
                <b-col lg="3">
                  <b-card-title class="card-title-page-garden-help-default my-1">Job No. {{ job_obj.order_id }}
                  </b-card-title></b-col>
                <b-col lg="9">
                  <b-row class="float-right">
                    <b-col md="auto" sm="auto" v-if="job_obj.details"> <label class="job-details-date-garden-help  my-1">
                        <img src="@/assets/images/garden-help/schedule-icon-active.png" />
                        Booking date:
                        <span id="booking_date">{{ formatDateToDMonYear(job_obj.details.booking_date_no_tz) }}</span>
                      </label></b-col>
                    <b-col md="auto" sm="auto" class="status-span-container"><span
                        :class="'jobStatusSpan ' + job_obj.status + '_status my-auto'">{{
                          getJobStatusClassAndStr(job_obj.status) }}</span></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-header>
          </b-card></b-col>
      </b-row>
      <!--  -->
      <b-row class="mx-auto">
        <b-col>
          <b-card class="job-details-card-garden-help" no-body>
            <b-card-body class="p-0">
              <b-row>
                <b-col xl="7" lg="6" md="6" sm="4">
                  <!-- customer data-->
                  <b-card class=" card-transparent-background  card-personal-details-garden-help my-1  py-1  " no-body
                    header="Personal Details" header-class="pb-0">
                    <b-card-body class="py-0">
                      <b-card-title class="mb-2" v-if="job_obj.contact">
                        {{ job_obj.contact.name }}
                      </b-card-title>
                      <b-card-sub-title class="mb-1" v-if="job_obj.contact">
                        {{ job_obj.contact.email }}
                      </b-card-sub-title>

                      <b-card-text class="mb-0" v-if="job_obj.contact">
                        <img src="@/assets/images/garden-help/phone-icon.png" />
                        {{ job_obj.contact.phone }}</b-card-text>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col xl="5" lg="6" md="6" sm="8">
                  <b-card no-body class="card-transparent-background card-job-garden-help-green w-100 p-0">
                    <template #header>
                      <b-row class="justify-content-center">
                        <!-- <b-col xl="3" lg="3" md="3" cols="3" class="position-relative p-0"> -->
                        <b-col xl="2" lg="3" md="2" cols="3" class="img-container position-relative p-0">
                          <img src="@/assets/images/garden-help/job-type-icon.png" />
                        </b-col>
                        <b-col xl="9" lg="9" md="8" cols="9" class="py-1" v-if="job_obj.property && job_obj.operator">
                          <b-row cols="1" cols-md="1" cols-lg="2">
                            <b-col class="p-1 px-2">
                              <b-card-sub-title>Contractor</b-card-sub-title>
                              <b-card-title>{{ job_obj.operator.name }}</b-card-title>
                            </b-col>
                            <b-col class="p-1 px-2">
                              <b-card-sub-title>Type of work</b-card-sub-title>
                              <b-card-title>{{ job_obj.property.type }}</b-card-title>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col xl="6" lg="6" md="6" cols="9" class="py-1 w-auto"
                          v-if="job_obj.property && job_obj.operator == null">
                          <b-row cols="1">
                            <b-col class="p-1 px-2">
                              <b-card-sub-title>Type of work</b-card-sub-title>
                              <b-card-title>{{ job_obj.property.type }}</b-card-title>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-col>
              </b-row>

              <b-row>
                <b-col xl="8" lg="7" md="7">
                  <!-- services list-->
                  <b-card class="card-transparent-background my-1 py-1" no-body header="Service Details"
                    header-class="pb-0">
                    <b-card-body class="py-0">
                      <b-list-group class="jobs-list-group-garden-help row mx-3 px-2" horizontal v-if="job_obj.services">
                        <b-list-group-item class="list-item col-xl-4 col-md-6"
                          v-for="(service, index) in job_obj.orig_services" :key="index">
                          <span class="check-span">
                            <font-awesome-icon icon="fa-solid fa-circle-check" /></span>
                          <p>{{ service.name }}</p>
                        </b-list-group-item>
                      </b-list-group></b-card-body>
                  </b-card>
                  <b-card v-if="job_obj.services.filter(item => item.type!='service').length>0" class="card-transparent-background my-1 py-1" no-body header="Extra Items"
                    header-class="pb-0">
                    <b-card-body class="py-0">
                      <b-list-group class="jobs-list-group-garden-help row mx-3 px-2" horizontal v-if="job_obj.services">
                        <b-list-group-item class="list-item col-xl-4 col-md-6"
                          v-for="(service, index) in job_obj.services.filter(item => item.type!='service')" :key="index">
                          <span class="check-span">
                            <font-awesome-icon icon="fa-solid fa-circle-check" /></span>
                          <p>{{ service.name }}</p>
                        </b-list-group-item>
                      </b-list-group></b-card-body>
                  </b-card>
                  <!-- short desc -->
                  <b-card v-if="job_obj.description" class="card-transparent-background my-1 pt-1" no-body
                    header="Short Description" header-class="pt-1 pb-0"><b-card-body class="py-0">
                      <b-card-text class="card-text-job">
                        {{ job_obj.description }}
                      </b-card-text></b-card-body>
                  </b-card>
                  <b-card v-if="job_obj.note" class="card-transparent-background my-1 pt-1" no-body header="More Details"
                    header-class="pt-1 pb-0"><b-card-body class="py-0">
                      <b-card-text class="card-text-job">
                        {{ job_obj.note }}
                      </b-card-text></b-card-body>
                  </b-card>
                </b-col>
                <b-col xl="4" lg="5" md="5">
                  <b-card class="card-transparent-background my-1 py-1" no-body v-if="job_obj.property">
                    <b-card-body class="pb-0">
                      <b-row>
                        <b-col v-if="job_obj.property.size">
                          <b-form-group class="form-group-job-details" label="Property Size"
                            label-for="property-size-val">
                            <span id="property-size-val">{{ job_obj.property.size }} {{ job_obj.property.size_unit
                            }}</span>
                          </b-form-group>
                        </b-col>
                        <b-col v-if="job_obj.last_service_date">
                          <b-form-group class="form-group-job-details" label="Last service" label-for="property-size-val">
                            <span id="property-size-val">{{ job_obj.last_service_date }}</span>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group class="form-group-job-details" label="First time doing service for this property"
                            label-for="property-size-val">
                            <span id="property-size-val">{{ job_obj.details.first_time == 1 ? "Yes" : "No" }}</span>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" v-if="job_obj.property.site_details">
                          <b-form-group class="form-group-job-details" label="Site details" label-for="property-size-val">
                            <span id="property-size-val">{{
                              job_obj.property.site_details.replace(",", ", ")
                            }}</span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <!-- map & property images-->
      <b-row cols-lg="2" cols="1" class="mb-4 mx-auto">
        <b-col class="my-1">
          <b-card class="job-details-card-garden-help job-images-card h-100" header="Property Information"
            header-class="pb-2" no-body>
            <b-card-body class="pt-1">
              <b-list-group class="jobs-list-group-garden-help">
                <b-list-group-item class="list-item">
                  <span class="check-span">
                    <font-awesome-icon icon="fa-solid fa-location-dot" /></span>
                  <p>{{ job_obj.location }}</p>
                </b-list-group-item>
              </b-list-group>
              <GmapMap :center="map_center" :zoom="map_zoom" map-type-id="hybrid" class="job-map-container-garden-help"
                ref="gmap">
                <GmapMarker v-if="job_obj.job_position != null" :position="job_obj.job_position" :clickable="false"
                  :draggable="false" />
                <gmap-polygon v-if="job_obj.property && job_obj.property.map_points" :paths="job_obj.property.map_points.points" ref="polygon"
                  :options="polyogn_options" :editable="false">
                </gmap-polygon>
              </GmapMap>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col class="my-1">
          <b-card class="job-details-card-garden-help job-images-card h-100" header="Property Images" header-class="pb-2"
            no-body>
            <b-card-body class="pt-1">
              <b-row cols="2"
                v-if="job_obj.property && job_obj.property.media != null && job_obj.property.media.length > 0">
                <b-col v-for="image in job_obj.property.media" :key="image.id" class="img-container my-1">
                  <b-img :src="image.path" class="property-img" />
                </b-col>
                <!-- <b-col
                v-for="image in job_obj.property_images"
                :key="image.id"
                class="img-container my-1"
              >
                <b-img :src="image.path" class="property-img" />
              </b-col> -->
              </b-row>
              <b-row v-else>
                <b-col>
                  <p class="no-results-p-garden-help ">No images found</p>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <!--- contractors quotes --->
      <b-row class="mb-1 mx-auto" v-if="user_type == 'user' && has_offers && job_obj.operator == null">
        <b-col>
          <b-card no-body class="p-0">
            <b-card-body class="p-0">
              <b-table class="gardenHelpTable " :items="job_obj.invoices" :fields="table_fields" :select-mode="'single'"
                responsive="sm" ref="selectableTable" selectable @row-selected="onRowSelected">
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(contractor)="data">
                  <router-link :to="'/garden_help/contractor_profile/' + data.item.owner.id" target="_blank">
                    {{ data.item.owner.name }}
                  </router-link>
                  <!-- <a :href="`#${data.value.replace(/[^a-z]+/i, '-').toLowerCase()}`">{{ data.value }}</a> -->
                </template>
                <template #cell(actions)="data" class="testtt">
                  <!-- {{data.item.id}} -->
                  <!-- <b-button class="btn-action" @click="clickViewQuote($event, data.item.id)">
                  </b-button> -->
                  <router-link :to="'/garden_help/quote/view/' + data.item.id" target="_blank">
                    <img src="@/assets/images/garden-help/view-icon.png" class="mx-1" />
                  </router-link>
                </template>

                <template #cell(actions_select)="{ rowSelected }">

                  <template v-if="rowSelected">
                    <img src="@/assets/images/garden-help/checked-circle-icon.png" class="mr-1" />
                  </template>
                  <template v-else>
                    <img src="@/assets/images/garden-help/not-checked-circle-icon.png" class="mr-1" />
                  </template>
                </template>


              </b-table>
            </b-card-body>
          </b-card>

        </b-col>
      </b-row>

      <b-row class="mx-auto" v-if="user_type == 'user' && has_offers && job_obj != null && job_obj.operator == null">
        <b-col>
          <b-card no-body class="mt-4">
            <b-card-body class="pl-0 pr-3">
              <SelectPayment ref="selectPayment" :cards_list="cards_list" :payment_method_id.sync="payment_method_id"
                :card_id="payment_method_id" :invalid_payment_method="invalid_payment_method" />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>


      <!-- buttons -- actions -->
      <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0"
        v-if="job_obj.status != 'canceled' && job_obj.status != 'complete'">
        <!-- customer & cancel job-->
        <!-- <b-col xl="3" lg="4" sm="4" class=" text-center"
          v-if="user_type == 'user' && job_obj != null && contact_id == job_obj.contact.id && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
          <b-button type="button" variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="cancelJob">Cancel job</b-button>
        </b-col> -->
        <!-- reschedule job  -->
        <b-col xl="3" lg="4" sm="4" class=" text-center" v-if="((user_type == 'admin') ||
          (job_obj.owner && job_obj.owner.type == user_type && job_obj.owner.id == user_id) ||
          (user_type == 'operator' && job_obj.operator != null && job_obj.operator.id == user_id && is_staff==0 && job_obj.status != 'assigned'))
          && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
          <b-button type="button" variant="garden-help-secondary" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="clickRescheduleJob">Reschedule Job</b-button>
        </b-col>

        <!-- accept quote -->
        <b-col xl="3" lg="4" sm="4" class="text-center"
          v-if="user_type == 'user' && has_offers && job_obj.operator == null">
          <b-button v-if="!is_loading_accept_quote" type="button" variant="garden-help-primary"
            class="btn-bumblebee btn-garden-help mb-1 w-100" :disabled="!selected_quote" @click="clickAcceptQuote">Accept
            quote</b-button>

          <b-button v-else-if="is_loading_accept_quote" type="button" disabled variant="garden-help-primary"
            class="btn-bumblebee btn-garden-help mb-1 w-100">
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>
        <!-- admin:  assign job -->
        <b-col xl="3" lg="4" sm="4" class=" text-center" v-if="user_type == 'admin' && job_obj.status == 'pending'">
          <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="clickAssignJob">Assign Contractor</b-button>
        </b-col>
        <!-- contractor company:  reassign job -->
        <b-col xl="3" lg="4" sm="4" class=" text-center"
         v-if="job_obj.status != 'complete' && user_type == 'operator' && is_company==1 && job_obj.owner && job_obj.owner.type == user_type && job_obj.owner.id == user_id">
          <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="clickReassignJobToStaff">Reassign Staff</b-button>
        </b-col>
        <!-- contractor: accept/reject assigned job -->
        <b-col xl="3" lg="4" sm="4" class="text-center"
          v-if="user_type == 'operator' && job_obj.operator != null && job_obj.operator.id == user_id && is_staff==0 && job_obj.status == 'assigned' &&  job_obj.owner.id != user_id">
          <!-- <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100">Accept &
            send quote</b-button> -->
          <router-link :to="'/garden_help/send_quote/job/' + job_id"
            class="btn btn-bumblebee btn-garden-help btn-garden-help-primary mb-1 w-100">Accept &
            send quote
          </router-link>
        </b-col>
        <b-col xl="3" lg="4" sm="4" class="text-center"
          v-if="user_type == 'operator' && job_obj.operator != null && job_obj.operator.id == user_id && is_staff==0 && job_obj.status == 'assigned'&&  job_obj.owner.id != user_id">
          <b-button type="button" variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="rejectJob">Reject</b-button>
        </b-col>
        
        <!-- contractor: send quote and the owner is himself and not create quote after add job  -->
        <b-col xl="3" lg="4" sm="4" class="text-center"
          v-if="user_type == 'operator' && job_obj.operator != null && job_obj.operator.id == user_id && is_staff==0 && job_obj.status == 'assigned' &&  job_obj.owner.id == user_id">
          <router-link :to="'/garden_help/send_quote/job/' + job_id+'/t'"
            class="btn btn-bumblebee btn-garden-help btn-garden-help-primary mb-1 w-100">Send quote
          </router-link>
        </b-col>
        <!-- contractor: send quote job -->
        <b-col xl="3" lg="4" sm="4" class="text-center"
          v-if="user_type == 'operator' && job_obj.operator == null && job_obj.status == 'pending'">
          <!-- <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100">Accept &
            send quote</b-button> -->
          <router-link :to="'/garden_help/send_quote/job/' + job_id"
            class="btn btn-bumblebee btn-garden-help btn-garden-help-primary mb-1 w-100">
            Send quote
          </router-link>
        </b-col>
        <!-- customer: contact contractor -->
        <b-col xl="3" lg="4" sm="4" class=" text-center" v-if="(
          (user_type == 'user' && job_obj.operator != null))
          && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
          <b-button type="button" variant="garden-help-info-outline" class="btn-bumblebee btn-garden-help mb-1 w-100"
            @click="clickContactContractor">Contact Contractor</b-button>
        </b-col>
      </b-row>

 
    </b-overlay>

    <!-- contractor -->
    <!-- <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto"
      v-if="user_type == 'operator' && job_obj.status == 'pending'">
      <b-col xl="3" lg="4" sm="4" class=" text-center">
        <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100">Send
          quote</b-button>
      </b-col>
    </b-row> -->
    <!--accept & reject -->
    <!-- <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto"
      v-if="user_type == 'operator' && job_obj.status == 'assigned'">
      <b-col xl="3" lg="4" sm="4" class="text-center">
        <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100">Accept &
          send quote</b-button>
      </b-col>
      <b-col xl="3" lg="4" sm="4" class="text-center">
        <b-button type="button" variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help mb-1 w-100"
          @click="rejectJob">Reject</b-button>
      </b-col>
    </b-row> -->
    <!--- all status expect complere and in progress - reschedule -->
    <!-- <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto" 
      v-if="job_obj.status != 'assigned' && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
      <b-col xl="3" lg="4" sm="4" class=" text-center">
        <b-button type="button" variant="garden-help-secondary"
          class="btn-bumblebee btn-garden-help mb-1 w-100">Reschedule Job</b-button>
      </b-col>
    </b-row> -->
    <!-- customer : accept quote & cancel job -->
    <!-- <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto" 
      v-if="user_type == 'user' && has_offers">
      <b-col xl="3" lg="4" sm="4" class="text-center">
        <b-button type="button" variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help mb-1 w-100"
          @click="cancelJob">Cancel job</b-button>
      </b-col>
      <b-col xl="3" lg="4" sm="4" class="text-center">
        <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
          :disabled="!selected_quote">Accept
          quote</b-button>
      </b-col>
    </b-row> -->
    <!-- pending job -- cancel job -->
    <!-- <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto"
      v-if="user_type == 'user' && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
      <b-col xl="3" lg="4" sm="4" class="text-center">
        <b-button type="button" variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help mb-1 w-100"
          @click="cancelJob">Cancel job</b-button>
      </b-col>
      <b-col xl="3" lg="4" sm="4" class=" text-center"  
          v-if="job_obj.status != 'assigned' && job_obj.status != 'in_progress' && job_obj.status != 'complete'">
        <b-button type="button" variant="garden-help-secondary"
          class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickRescheduleJob">Reschedule Job</b-button>
      </b-col>
    </b-row> -->
    <!---- cancel job ---->
    <CancelJob :client_name="client_name" :job_id="job_id" />
    <!---- reject job ---->
    <RejectJob :client_name="client_name" :job_id="job_id" />
    <!---- reschedule job ---->
    <RescheduleJob :client_name="client_name" :job_id="job_id"  :booking_date="job_obj.details.booking_date_no_tz"/>
    <!---- assign contractor job ---->
    <AssignJob :client_name="client_name" :job_id="job_id" />
    <!---- assign staff job ---->
    <ReassignJobStaff :client_name="client_name" :job_id="job_id" :assigned_operator_obj="job_obj.operator"/>
    <!---- accept quote job ---->
    <AcceptQuote :client_name="client_name" :quote_id="selected_quote_id" />
    <!---- contact contractor ---->
    <ContactContractor v-if="job_obj" :client_name="client_name" :operator_data="job_obj.operator" />
  </div>
</template>  
<script>
import { getJobStatusClassAndStr } from "@/utils/helper-functions-garden-help.js"
import { formatDateToDMonYear } from "@/utils/helper-functions.js"

import CancelJob from "./modal_actions/CancelJob.vue";
import RejectJob from "./modal_actions/RejectJob.vue";
import RescheduleJob from "./modal_actions/RescheduleJob.vue"
import AssignJob from "./modal_actions/AssignJob.vue"
import ReassignJobStaff from "./modal_actions/ReassignJobStaff.vue"
import AcceptQuote from './modal_actions/AcceptQuote.vue'
import ContactContractor from './modal_actions/ContactContractor.vue'

import SelectPayment from "../components/SelectPayment.vue"

import axios from "axios";
import ReassignJobStaffVue from './modal_actions/ReassignJobStaff.vue';

export default {
  name: "GardenHelpJobsDetails",
  components: {
    CancelJob, RejectJob, RescheduleJob,
    AssignJob, SelectPayment, AcceptQuote,
    ContactContractor, ReassignJobStaff
  },
  data() {
    return {
      client_name: "GARDENHELP",
      show_overlay: false,
      user_id: null,
      contact_id: null,

      job_id: null,
      job_obj: {
        booking_date: "",

        customer_name: "",
        customer_email: "",
        customer_phone: "",

        location: "",
        property_type: "",

        services: [],
        short_description:
          "",

        property_size: "",
        last_service: "",
        first_service: "",
        site_details: "",

        address: "",
        job_position: {},
        paths: [],
        property_images: [],

        status: "",
      },
      map_zoom: 18,
      map_center: { lat: 53.37261915086474, lng: -6.273212434869104 },
      polyogn_options: {
        fillColor: "#0068B8",
        fillOpacity: 0.5,
        strokeColor: "#0068B8",
        strokeWeight: 3,
        editable: false,
      },

      table_fields: [
        {
          key: 'contractor', label: "Contractor"
        },
        {
          key: 'owner.experience_level', label: "Level"
        },
        {
          key: 'total', label: "Quote"
        },
        { key: 'actions', label: "", class: "text-center actionTd" },
        { key: 'actions_select', label: "", class: "text-center actionTd" }
      ],
      contractors_quotes: [],
      cards_list: [
        { title: "New card", value: "new" }
      ],
      user_type: localStorage.getItem('user_type'),
      is_staff: false,
      has_offers: false,
      selected_quote: false,
      selected_quote_id: null,

      payment_method_id: null,
      invalid_payment_method: false,

      is_loading_accept_quote: false,
      base_url: null,

      
      is_company: 0,

    };
  },
  async mounted() {

    console.log(this.$route)

    this.job_id = Number(this.$route.params.id);
    this.user_type = localStorage.getItem('user_type')
    let user = JSON.parse(window.localStorage.getItem("user"));
    this.user_id = user.id
    this.is_company = user.is_company != null ? user.is_company : 0
    this.is_staff = user.is_staff

    this.show_overlay = true
    let status_param = this.$route.params.status
    if (status_param == 'history') {
      this.job_obj.status = 'complete'
    } else if (status_param == 'offers') {
      this.has_offers = true
    } else if (status_param == 'requests') {
      this.job_obj.status = 'pending'
    }
    console.log(this.$route.params.status)

    if (this.user_type == 'user' && this.has_offers) {
      await this.getCustomerCardsList()
    }
    await this.getContactDetails()
    this.getJobDetails()

    this.base_url = this.$route.path
  },
  methods: {
    getJobStatusClassAndStr, formatDateToDMonYear,
    cancelJob() {
      console.log("click cancel job", this.job_id)
      this.$root.$emit("bv::show::modal", "cancelJobModal");
    },
    rejectJob() {
      console.log("click reject job", this.job_id)
      this.$root.$emit("bv::show::modal", "rejectJobModal");
    },
    clickRescheduleJob() {
      console.log("click reschedule job", this.job_id)
      this.$root.$emit("bv::show::modal", "rescheduleJobModal");
    },
    clickAssignJob() {
      console.log("click assign job", this.job_id)
      this.$root.$emit("bv::show::modal", "assignJobModal");
    },
    clickReassignJobToStaff(){
      console.log("click reassign job", this.job_id)
      this.$root.$emit("bv::show::modal", "reassignJobToStaffModal");
    },
    async clickAcceptQuote() {
      console.log("click accept quote", this.payment_method_id)
      if (this.payment_method_id == null) {
        this.$root.$emit("bv::show::modal", "acceptQuoteModal");
      } else {
        this.is_loading_accept_quote = true
        if (this.payment_method_id == 'new') {
          let saved_card = await this.$refs.selectPayment.$refs.stripeComponentUserRef.purchase()
          console.log("after save card and before save job request", saved_card)
          if (!saved_card) {
            this.is_loading = false
            return;
          }
        }
        await this.updateJobWithPaymentMethod()
      }
    },
    onRowSelected(items) {
      console.log("on selected")
      console.log(items)
      if (items.length > 0) {
        this.selected_quote = true
        this.selected_quote_id = items[0].id
      } else {
        this.selected_quote = false
        this.selected_quote_id = null
      }
    },
    getContactDetails() {
      axios
        .get("/common/contacts", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);

          if (this.user_type == 'user') {
            this.contact_id = response.data[0].id
          }
        });
    },
    getCustomerCardsList() {
      axios
        .get("payment/pm/get-user-pms", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log("---- cards")
          console.log(response);
          this.cards_list = []
          for (let i = 0; i < response.data.payment_methods.length; i++) {
            let item = response.data.payment_methods[i]
            this.cards_list.push({ title: "**** **** **** " + item.last_four, value: item.id })
          }
          this.cards_list.push({ title: "New card", value: "new" })


        });
    },
    getJobDetails() {
      this.show_overlay = true
      axios
        .get("/jobs/jobs/" + this.job_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response)
          console.log(response.data)
          console.log(response)

          this.job_obj = response.data

          console.log(this.job_obj.location_lat, Number(this.job_obj.location_lat))
          this.map_center = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }
          this.job_obj.job_position = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }
          this.payment_method_id = this.job_obj.payment_method_id

          this.show_overlay = false
        });
    },
    updateJobWithPaymentMethod() {
      console.log("in edit job ", this.job_id, this.payment_method_id)
      let requestData = {
        payment_method_id: this.payment_method_id,
        client: this.client_name
      }
      console.log(requestData)

      axios
        .post("jobs/job-action/" + this.job_id, requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);

          this.is_loading_accept_quote = false
          this.$root.$emit("bv::show::modal", "acceptQuoteModal");

        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    clickViewQuote(event, id) {
      console.log("click view quote", id)
    },
    clickContactContractor() {
      console.log('click contact contractor', this.job_obj.operator)
      this.$root.$emit("bv::show::modal", "contactContractorModal");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/JobDetails.vue